var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',[_c('v-avatar',{class:`${_vm.color} white--text`},[_c('strong',[_vm._v(_vm._s(Math.min(_vm.value, 100)))])]),_c('span',{staticClass:"chip-text"},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }